import { useState } from 'react';
import TextField from '@base/Inputs/Text/TextField';
import DialogConfirm from '@base/Dialog/DialogConfirm';

export const DialogCartaoLegivel = (props) => {
    const [codigo, setCodigo] = useState('');
    const [erro, setErro] = useState('');

    const handleConfirm = (id, setLoading) => {
        
        let novoCodigo = null;
        let codigoInformadoManualmente = false;
        
        if(props.motivoIlegibilidade === 'CODIGO'){
            novoCodigo = codigo;
            codigoInformadoManualmente = true;
        }   

        setErro('');

        props.handleConfirm(id, novoCodigo, codigoInformadoManualmente, setLoading, (mensagemErro) => {
            setErro(mensagemErro);
            setCodigo('');
            setLoading(false);
        });
    };

    return (
        <DialogConfirm
            open={props.open}
            close={props.close}
            title={props.title}
            text={props.text}
            id={props.id}
            maxWidth={props.maxWidth}
            handleConfirm={handleConfirm}
        >
            {props.motivoIlegibilidade === 'CODIGO' && (
                <TextField
                    label="Código do cartão"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                    fullWidth
                    margin="normal"
                    inputProps={{ maxLength: 16 }}
                    error={!!erro}
                    helperText={erro || `${codigo.length}/16 caracteres`}
                />
            )}
        </DialogConfirm>
    );
};

export default DialogCartaoLegivel;